import * as React from "react";

function SvgRubbishTruck(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill } = props;
  return (
    <svg width={13} height={13} viewBox="0 0 13 13" fill="none" {...props}>
      <g clipPath="url(#clip0)">
        <path
          d="M9.08102 5.00369H11.7876L12.7036 6.44119V8.4399H13V9.08317H12.7034H12.6529H12.0672C12.0674 9.07869 12.068 9.07435 12.068 9.06988C12.068 8.50332 11.6071 8.04235 11.0404 8.04235C10.4737 8.04235 10.0128 8.50332 10.0128 9.06988C10.0128 9.07435 10.0133 9.07869 10.0135 9.08317H9.08102V5.00369ZM10.6182 6.50099H10.6217V6.50388H12.2264V6.44263H12.2195L11.5303 5.36094V5.34086H10.6794V5.34028H10.6182V6.50099Z"
          fill={fill ?? "black"}
        />
        <path
          d="M3.90365 10.0474C4.36663 10.0474 4.74309 9.6711 4.74309 9.20797C4.74309 8.74528 4.36678 8.36882 3.90365 8.36882C3.4408 8.36882 3.06435 8.74513 3.06435 9.20797C3.06449 9.67096 3.4408 10.0474 3.90365 10.0474ZM3.90365 8.7278C4.16858 8.7278 4.38397 8.94333 4.38397 9.20797C4.38397 9.47291 4.16858 9.68844 3.90365 9.68844C3.63886 9.68844 3.42347 9.47291 3.42347 9.20797C3.42347 8.94333 3.63886 8.7278 3.90365 8.7278Z"
          fill={fill ?? "black"}
        />
        <path
          d="M11.0407 9.92231C11.5034 9.92231 11.88 9.546 11.88 9.08316C11.88 8.62031 11.5036 8.24371 11.0407 8.24371C10.5779 8.24371 10.2013 8.62031 10.2013 9.08316C10.2013 9.546 10.5779 9.92231 11.0407 9.92231ZM11.0407 8.60283C11.3055 8.60283 11.5209 8.81837 11.5209 9.0833C11.5209 9.34823 11.3055 9.56348 11.0407 9.56348C10.7758 9.56348 10.5603 9.34823 10.5603 9.0833C10.5603 8.81837 10.7758 8.60283 11.0407 8.60283Z"
          fill={fill ?? "black"}
        />
        <path
          d="M4.14172 4H8.83528V9.20797H4.93768C4.9046 8.67103 4.45851 8.24387 3.91319 8.24387C3.36786 8.24387 2.92178 8.67103 2.88869 9.20797H1.37984"
          fill={fill ?? "black"}
        />
        <path
          d="M9.53674e-07 8.07297C9.53674e-07 7.79056 0.103577 7.53299 0.274037 7.33436H0.273604L2.82515 4.45952C3.03202 4.18115 3.36239 4 3.73581 4C3.77409 4 3.81165 4.00217 3.84892 4.00578L1.08993 9.20797L1.09109 9.20595C0.484656 9.18226 9.53674e-07 8.68489 9.53674e-07 8.07297Z"
          fill={fill ?? "black"}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width={13} height={13} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgRubbishTruck;
